module.exports = __webpack_public_path__ + "static/media/_MG_0887.69b6765c.jpg";